module.exports = __webpack_public_path__ + "static/img/gengxin2.5284381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/gengxin2.png
// module id = En+6
// module chunks = 24